<template>
  <div class="edu-page">
    <div class="header-wrap app-flex-mid-center">
      <div class="image-wrap">
        <img src="../../../assets/area/edu1.png" class="bg" />
      </div>
      <div class="text-wrap">
        <m-base-text title="智能管理，教育信息化" color="#fff" shadow-color="rgba(255,255,255, 0.3)" type="large"></m-base-text>
      </div>
    </div>

    <div class="main">
      <m-base-title title="教育信息化" rich-title="Educational informatization"></m-base-title>
      <div class="desc-cont">
        <div class="article-section">
          我司与国内领先职业教育信息化的高新技术企业建立了战略合作关系，专业提供职教领域教育信息化建设及教学仪器设备整体解决方案。先后承接四川邮电职业学院、四川仁寿新科综合高中学校、四川华蓥职业技术学校、成都航空职业技术学院信息化建设业务，获得了客户的高度认可和肯定，并保持后续良好的合作关系。
        </div>
        <div class="article-section">
          我司自成立以来，始终以“一流的服务、卓越的产品、精湛的技术”为宗旨，坚持以市场需求为导向，始终把“扎根行业、精益求精”作为发展的理念。
        </div>
      </div>

      <div class="core-container">
        <div class="core-wrap">
          <img src="../../../assets/area/edu2.png" class="i-core" />
        </div>
        <m-base-title title="教育信息化" rich-title="Educational informatization" class="core-title"></m-base-title>
      </div>

      <m-base-text title="智能管家式服务，汇聚校园管理与生活所需" class="title-1"></m-base-text>
      <div class="banner-container">
        <div class="banner-item" v-for="item in bannerList" :key="item.id">
          <div class="banner-image-wrap app-flex-mid-center">
            <img :src="require('../../../assets/area/edu-' + item.id + '.png')" class="banner-img" />
          </div>
          <p class="title-name">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <m-base-foot></m-base-foot>
  </div>
</template>

<script>
import MBaseText from '../components/MBaseText.vue'
import MBaseTitle from '../components/MBaseTitle.vue'
import MBaseFoot from '../components/MBaseFoot.vue'

export default {
  name: 'EduPage',
  components: {
    MBaseText,
    MBaseTitle,
    MBaseFoot
  },
  data() {
    return {
      bannerList: [
        { id: 1, name: '掌上校园' },
        { id: 2, name: '网络教学' },
        { id: 3, name: '考勤门禁' },
        { id: 4, name: '生活服务' },
        { id: 5, name: '后勤保障' },
        { id: 6, name: '家校互动' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.edu-page {
  width: 100%;
  background: linear-gradient(180deg, #d3e5f7 0%, #ffffff 20%);
  .header-wrap {
    position: relative;
    .image-wrap {
      width: 100%;
      height: 190px;
      overflow: hidden;
      .bg {
        height: 190px;
        width: auto;
      }
    }
    .text-wrap {
      position: absolute;
    }
  }

  .main {
    padding: 0px 0px 35px;
    .desc-cont {
      padding: 0px 20px;
      margin-top: 20px;
      .article-section {
        color: #4c4c4c;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
        text-indent: 28px;
        &:not(:last-child) {
          margin-bottom: 35px;
        }
      }
    }
    .core-container {
      position: relative;
      width: 100%;
      padding: 0px 13px 0px 4px;
      margin-top: 35px;
      .core-wrap {
        width: 100%;
        overflow: hidden;
        .i-core {
          margin-top: 25px;
          height: auto;
          width: inherit;
        }
      }

      .core-title {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        margin: auto;
      }
    }

    .title-1 {
      margin: 35px 0px 20px;
    }

    .banner-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0px 14px;
      .banner-item {
        width: 112px;
        &:nth-child(-n + 3) {
          margin-bottom: 15px;
        }
        .banner-image-wrap {
          width: inherit;
          height: 59px;
          overflow: hidden;
          transition: all 0.3s;
          //   &:hover {
          //     transform: scale(1.01);
          //     box-shadow: 0 0.5rem 0.9375rem 0 rgb(0 0 0 / 20%);
          //   }
          .banner-img {
            width: 112px;
            height: auto;
          }
        }
        .title-name {
          margin-top: 5px;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #202020;
          line-height: 14px;
          text-align: center;
        }
      }
    }
  }
}
</style>
